<button
  type="button"
  [class]="buttonClasses()"
  [awTooltip]="tooltip()"
  [actionTooltip]="true"
  [fromTop]="tooltipFromTop()"
  [disabled]="disabled()"
  (click)="onButtonClick($event)"
>
  <i awIcon class="action-dropdown-button__icon">chevron-down</i>
</button>
